import React, { useEffect, useRef } from 'react';
import { styled } from 'styled-components';
import InlineMessage from '@ingka/inline-message';
import colors from '../styles/colors';
import { useTranslation } from 'react-i18next';

const StyledInlineMessage = styled(InlineMessage)`
  &&& {
    margin-bottom: 1.5rem;
    background-color: ${colors.background.error};
  }
`;

interface ErrorSummaryProps {
  text: string;
  submitCount: number;
}

const ErrorSummary: React.FC<ErrorSummaryProps> = ({ text, submitCount }) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    containerRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    containerRef.current?.focus();
  }, [submitCount]);

  return (
    <div ref={containerRef} tabIndex={-1}>
      <StyledInlineMessage
        variant="negative"
        title={t('components.error.questions.errorSummaryHeading')}
        body={text}
        role="alert"
        aria-live="assertive"
      />
    </div>
  );
};

export default ErrorSummary;
